import { auth } from "../../firebaseConfig";

const SERVER_URL = (
  process.env.REACT_APP_SERVER_URL ||
  (process.env.NODE_ENV === "development"
    ? "http://localhost:5000"
    : "https://rosemountstaffserver.onrender.com")
).replace(/\/$/, "");

export const parseReferenceSender = (value) => {
  if (value && typeof value === "object") {
    const email = String(value.email || value.address || "").trim().toLowerCase();
    return email ? { name: String(value.name || "").trim(), email } : null;
  }
  const raw = String(value || "").trim();
  if (!raw) return null;
  const match = raw.match(/^(.*?)\s*<([^<>]+)>$/);
  const email = (match ? match[2] : raw).trim().toLowerCase();
  return email
    ? { name: match ? match[1].trim() : "", email }
    : null;
};

const getConfiguredReferenceSender = () =>
  parseReferenceSender(
    process.env.REACT_APP_REFERENCE_CHASING_SENDER ||
      process.env.REACT_APP_REFERENCE_SENDER,
  );

const getAuthenticatedHeaders = async () => {
  const user = auth.currentUser;
  if (!user) throw new Error("You must be logged in to view reference email details.");
  const idToken = await user.getIdToken();
  return { Authorization: `Bearer ${idToken}` };
};

export const sendReferenceEmail = async ({
  applicationId,
  referenceId,
  followUpTimeframe = "",
  sender,
  from,
}) => {
  const response = await fetch(`${SERVER_URL}/api/recruitment/references/send`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(await getAuthenticatedHeaders()),
    },
    body: JSON.stringify({
      applicationId,
      referenceId,
      followUpTimeframe,
      sender: parseReferenceSender(sender || from) || getConfiguredReferenceSender() || undefined,
    }),
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok || !payload.ok) {
    throw new Error(payload.error || "The reference email could not be sent.");
  }
  return payload.result;
};
